import { allowed } from './editorRestrictionsApi';

import type { UIResourceRestriction } from '@/editorRestrictions';

// TODO: will have an effect (probably with subscription)
export const useUXResourceRestrictions = (
  uiResourceTypes: UIResourceRestriction[],
): boolean[] => {
  return uiResourceTypes.map(allowed);
};
